import * as React from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { validEmail } from "../../Variables";
import { useContextStateManagement } from "../../context/ContextApi";
import { Popover, OverlayTrigger } from "react-bootstrap";
import {
  faArrowLeftLong,
  faCircleInfo,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./Auth.css";

const { useState } = React;

const REGISTER_STEPS = [
  { id: 1, label: "Step 1", title: "Basic Details" },
  { id: 2, label: "Step 2", title: "Additional Information" },
  { id: 3, label: "Step 3", title: "Review & Register" },
];

export const Register = ({
  setCurrentRoute,
  setRegisterdUserToken,
  setRegisteredUserEmail,
}) => {
  const [practiceNameMessage, setPracticeNameMessage] = useState("");
  const [practiceAddressMessage, setPracticeAddressMessage] = useState("");
  const [emailMessage, setEmailMessage] = useState("");
  const [passwordMessage, setPasswordMessage] = useState("");
  const [nameMessage, setNameMessage] = useState("");
  const [professionMessage, setProfessionMessage] = useState("");
  const [currentStep, setCurrentStep] = useState(1);
  const [formValues, setFormValues] = useState({
    newUserName: "",
    userProfession: "",
    userEmail: "",
    userPassword: "",
    practiceName: "",
    practiceAddress: "",
    accountSID: "",
    authToken: "",
  });
  const { setCurrentUrl } = useContextStateManagement();
  const navigate = useNavigate();

  const checkOrgName = (event) => {
    const orgName = event.target.value;

    if (orgName !== "") {
      axios
        .post("/api/checkOrganizationName", { practiceName: orgName })
        .then(() => {})
        .catch((error) => {
          if (error?.response) {
            if (error.response.request.status === 409) {
              setPracticeNameMessage("Organization already exists");
            } else if (error.response.status !== 400) {
              alert(error.response.data.error);
            }
          } else if (error) {
            alert("Server is not responding");
          }
        });
    }
  };

  const handleRegister = (event) => {
    event.target.disabled = true;

    // Read from formValues state, not document.getElementById - the Register button only
    // exists on Step 3 (Review & Register), by which point Steps 1 and 2's <input> elements
    // (practiceName, accountSID, authToken, userEmail, etc.) are unmounted since each step is
    // conditionally rendered. getElementById returned null for all of them here, and
    // null.value threw immediately - before the API call ever fired, crashing the whole page
    // (no error boundary anywhere in this app) with no message, no alert, nothing. formValues
    // already tracks every field's live value via handleFieldChange regardless of which step
    // is currently mounted, same as what Step 3's own review summary already reads from.
    let isFieldEmpty = false;

    const user = {
      PracticeName: formValues.practiceName,
      PracticeAddress: formValues.practiceAddress,
      PracticeContactNumber: "",
      OutBoundContactNumber: "",
      accountSID: formValues.accountSID || "",
      authToken: formValues.authToken || "",
      KeragonId: "",
      UserName: formValues.newUserName,
      UserProfession: formValues.userProfession,
      UserEmail: formValues.userEmail,
      UserPassword: formValues.userPassword,
    };

    if (user.PracticeName === "") {
      isFieldEmpty = true;
      setPracticeNameMessage("Enter practice name");
    }

    if (user.PracticeAddress === "") {
      isFieldEmpty = true;
      setPracticeAddressMessage("Enter practice address");
    }

    if (user.UserName === "") {
      isFieldEmpty = true;
      setNameMessage("Enter user name");
    }

    if (user.UserProfession === "") {
      isFieldEmpty = true;
      setProfessionMessage("Enter user profession");
    }

    if (user.UserEmail === "") {
      isFieldEmpty = true;
      setEmailMessage("Enter your email");
    } else if (validEmail.test(user.UserEmail) === false) {
      isFieldEmpty = true;
      setEmailMessage("Enter a valid email");
    }

    if (user.UserPassword === "") {
      isFieldEmpty = true;
      setPasswordMessage("Enter password");
    } else if (user.UserPassword.length < 6) {
      isFieldEmpty = true;
      setPasswordMessage("Enter 6 digits / characters or more");
    }

    if (isFieldEmpty === true) {
      event.target.disabled = false;
      return;
    }

    axios
      .post("/api/register", user)
      .then((response) => {
        setFormValues({
          newUserName: "",
          userProfession: "",
          userEmail: "",
          userPassword: "",
          practiceName: "",
          practiceAddress: "",
          accountSID: "",
          authToken: "",
        });
        setCurrentStep(1);

        if (response) {
          alert("User registered successfully");
          setCurrentRoute("UserEmailNotification");
          navigate("/UserEmailNotification");
          setRegisterdUserToken(response.data ? response.data.token : "");
          setRegisteredUserEmail(user.UserEmail);
        } else {
          alert("Username already exist");
        }

        event.target.disabled = false;
      })
      .catch((error) => {
        if (error) {
          alert(
            error.response
              ? error.response.data.error
              : "Server is not responding, Check your connection string",
          );
        }
        event.target.disabled = false;
      });
  };

  const resetErrorFieldStyle = (event) => {
    if (event.target.classList.contains("empty")) {
      event.target.classList.remove("empty");
    }

    if (event.target.id === "practiceName") {
      setPracticeNameMessage("");
    } else if (event.target.id === "practiceAddress") {
      setPracticeAddressMessage("");
    } else if (event.target.id === "newUserName") {
      setNameMessage("");
    } else if (event.target.id === "userProfession") {
      setProfessionMessage("");
    } else if (event.target.id === "userEmail") {
      setEmailMessage("");
    } else if (event.target.id === "userPassword") {
      setPasswordMessage("");
    }
  };

  const handleFieldChange = (event) => {
    const { id, value } = event.target;
    setFormValues((currentValues) => ({
      ...currentValues,
      [id]: value,
    }));
  };

  const nextStep = () => {
    setCurrentStep((step) => Math.min(step + 1, REGISTER_STEPS.length));
  };

  const previousStep = () => {
    setCurrentStep((step) => Math.max(step - 1, 1));
  };

  const loginHandle = () => {
    navigate("/login");
    setCurrentUrl(window.location.href);
    setCurrentRoute("login");
  };

  return (
    <div className="row login-start login-page-shell">
      <div className="col-12">
        <div className="login-layout login-layout--centered">
          <section className="login-form-panel login-form-panel--centered auth-flip-card glass-panel setting-login auth-register-panel">
            <div className="login-form-header">
              <p className="login-form-eyebrow">Create account</p>
            </div>

            <div className="auth-stepper" aria-label="Create account steps">
              {REGISTER_STEPS.map((step) => {
                const isActive = step.id === currentStep;
                const isCompleted = step.id < currentStep;

                return (
                  <button
                    key={step.id}
                    type="button"
                    className={`auth-stepper__item${isActive ? " is-active" : ""}${isCompleted ? " is-complete" : ""}`}
                    onClick={() => setCurrentStep(step.id)}
                  >
                    <span className="auth-stepper__dot">{step.id}</span>
                    <span className="auth-stepper__copy">
                      <span className="auth-stepper__label">{step.label}</span>
                      <span className="auth-stepper__title">{step.title}</span>
                    </span>
                  </button>
                );
              })}
            </div>

            <div className="auth-register-flow">
              {currentStep === 1 ? (
                <section className="auth-form-section auth-step-panel" key="step-1">
                  <div className="auth-form-section__header auth-step-panel__header">
                    <div>
                      <p className="auth-step-panel__eyebrow">Step 1</p>
                      <h3 className="auth-form-section__title">Basic Details</h3>
                    </div>
                  </div>
                  <div className="auth-form-grid">
                    <div className="auth-form-field">
                      <label className="login-field-label form-label auth-inline-label">
                        <span>Username <span className="required-star" aria-hidden="true">*</span></span>
                        <OverlayTrigger
                          placement="right"
                          overlay={
                            <Popover id="username-popover">
                              <Popover.Body>
                                name displayed in the application
                              </Popover.Body>
                            </Popover>
                          }
                        >
                          <FontAwesomeIcon icon={faCircleInfo} className="info-icon" />
                        </OverlayTrigger>
                      </label>
                      <input
                        type="text"
                        id="newUserName"
                        className="login-field-input form-control"
                        placeholder="Enter user name"
                        value={formValues.newUserName}
                        onChange={handleFieldChange}
                        onFocus={resetErrorFieldStyle}
                        aria-required="true"
                      />
                      <small className="login-field-error">{nameMessage}</small>
                    </div>

                    <div className="auth-form-field">
                      <label className="login-field-label form-label auth-inline-label">
                        <span>User Profession <span className="required-star" aria-hidden="true">*</span></span>
                        <OverlayTrigger
                          placement="right"
                          overlay={
                            <Popover id="prof-popover">
                              <Popover.Body>role in the organization</Popover.Body>
                            </Popover>
                          }
                        >
                          <FontAwesomeIcon icon={faCircleInfo} className="info-icon" />
                        </OverlayTrigger>
                      </label>
                      <input
                        type="text"
                        id="userProfession"
                        className="login-field-input form-control"
                        placeholder="Enter user profession"
                        value={formValues.userProfession}
                        onChange={handleFieldChange}
                        onFocus={resetErrorFieldStyle}
                        aria-required="true"
                      />
                      <small className="login-field-error">{professionMessage}</small>
                    </div>

                    <div className="auth-form-field">
                      <label className="login-field-label form-label auth-inline-label">
                        <span>User Email <span className="required-star" aria-hidden="true">*</span></span>
                        <OverlayTrigger
                          placement="right"
                          overlay={
                            <Popover id="email-popover">
                              <Popover.Body>
                                unique email address used for login
                              </Popover.Body>
                            </Popover>
                          }
                        >
                          <FontAwesomeIcon icon={faCircleInfo} className="info-icon" />
                        </OverlayTrigger>
                      </label>
                      <input
                        type="email"
                        id="userEmail"
                        className="login-field-input form-control"
                        placeholder="Enter user email"
                        value={formValues.userEmail}
                        onChange={handleFieldChange}
                        onFocus={resetErrorFieldStyle}
                        aria-required="true"
                      />
                      <small className="login-field-error">{emailMessage}</small>
                    </div>

                    <div className="auth-form-field">
                      <label className="login-field-label form-label auth-inline-label">
                        <span>User Password <span className="required-star" aria-hidden="true">*</span></span>
                        <OverlayTrigger
                          placement="right"
                          overlay={
                            <Popover id="pass-popover">
                              <Popover.Body>
                                must be at least 6 characters long
                              </Popover.Body>
                            </Popover>
                          }
                        >
                          <FontAwesomeIcon icon={faCircleInfo} className="info-icon" />
                        </OverlayTrigger>
                      </label>
                      <input
                        type="password"
                        id="userPassword"
                        className="login-field-input form-control"
                        placeholder="Enter password"
                        value={formValues.userPassword}
                        onChange={handleFieldChange}
                        onFocus={resetErrorFieldStyle}
                        aria-required="true"
                      />
                      <small className="login-field-error">{passwordMessage}</small>
                    </div>
                  </div>
                </section>
              ) : null}

              {currentStep === 2 ? (
                <section className="auth-form-section auth-step-panel" key="step-2">
                  <div className="auth-form-section__header auth-step-panel__header">
                    <div>
                      <p className="auth-step-panel__eyebrow">Step 2</p>
                      <h3 className="auth-form-section__title">Additional Information</h3>
                    </div>
                  </div>
                  <div className="auth-form-grid">
                    <div className="auth-form-field">
                      <label className="login-field-label form-label auth-inline-label">
                        <span>Organization Name <span className="required-star" aria-hidden="true">*</span></span>
                        <OverlayTrigger
                          placement="right"
                          overlay={
                            <Popover id="name-popover">
                              <Popover.Body>name of the organization</Popover.Body>
                            </Popover>
                          }
                        >
                          <FontAwesomeIcon icon={faCircleInfo} className="info-icon" />
                        </OverlayTrigger>
                      </label>
                      <input
                        type="text"
                        id="practiceName"
                        className="login-field-input form-control"
                        placeholder="Enter organization name"
                        value={formValues.practiceName}
                        onChange={handleFieldChange}
                        onFocus={resetErrorFieldStyle}
                        onBlur={checkOrgName}
                        aria-required="true"
                      />
                      <small className="login-field-error">
                        {practiceNameMessage}
                      </small>
                    </div>

                    <div className="auth-form-field auth-form-field--full">
                      <label className="login-field-label form-label auth-inline-label">
                        <span>Organization Address <span className="required-star" aria-hidden="true">*</span></span>
                        <OverlayTrigger
                          placement="right"
                          overlay={
                            <Popover id="address-popover">
                              <Popover.Body>
                                full address of the organization, including street,
                                city, state, and zip code
                              </Popover.Body>
                            </Popover>
                          }
                        >
                          <FontAwesomeIcon icon={faCircleInfo} className="info-icon" />
                        </OverlayTrigger>
                      </label>
                      <input
                        type="text"
                        id="practiceAddress"
                        className="login-field-input form-control"
                        placeholder="Enter organization address"
                        value={formValues.practiceAddress}
                        onChange={handleFieldChange}
                        onFocus={resetErrorFieldStyle}
                        aria-required="true"
                      />
                      <small className="login-field-error">
                        {practiceAddressMessage}
                      </small>
                    </div>

                    <div className="auth-form-field">
                      <label className="login-field-label form-label">
                        Twilio Account SID
                      </label>
                      <input
                        type="text"
                        id="accountSID"
                        name="username"
                        autoComplete="username"
                        className="login-field-input form-control"
                        placeholder="Enter account SID"
                        value={formValues.accountSID}
                        onChange={handleFieldChange}
                        onFocus={resetErrorFieldStyle}
                      />
                    </div>

                    <div className="auth-form-field">
                      <label className="login-field-label form-label">
                        Twilio Auth Token
                      </label>
                      <input
                        type="password"
                        id="authToken"
                        name="password"
                        autoComplete="new-password"
                        className="login-field-input form-control"
                        placeholder="Enter auth token"
                        value={formValues.authToken}
                        onChange={handleFieldChange}
                        onFocus={resetErrorFieldStyle}
                      />
                    </div>
                  </div>
                </section>
              ) : null}

              {currentStep === 3 ? (
                <section className="auth-form-section auth-step-panel" key="step-3">
                  <div className="auth-form-section__header auth-step-panel__header">
                    <div>
                      <p className="auth-step-panel__eyebrow">Step 3</p>
                      <h3 className="auth-form-section__title">Review & Register</h3>
                    </div>
                  </div>

                  <div className="auth-review-grid">
                    <div className="auth-review-card">
                      <p className="auth-review-card__title">Basic details</p>
                      <dl className="auth-review-list">
                        <div className="auth-review-list__row">
                          <dt>Username</dt>
                          <dd>{formValues.newUserName || "Not added"}</dd>
                        </div>
                        <div className="auth-review-list__row">
                          <dt>Profession</dt>
                          <dd>{formValues.userProfession || "Not added"}</dd>
                        </div>
                        <div className="auth-review-list__row">
                          <dt>Email</dt>
                          <dd>{formValues.userEmail || "Not added"}</dd>
                        </div>
                        <div className="auth-review-list__row">
                          <dt>Password</dt>
                          <dd>{formValues.userPassword ? "••••••••" : "Not added"}</dd>
                        </div>
                      </dl>
                    </div>

                    <div className="auth-review-card">
                      <p className="auth-review-card__title">Additional information</p>
                      <dl className="auth-review-list">
                        <div className="auth-review-list__row">
                          <dt>Organization</dt>
                          <dd>{formValues.practiceName || "Not added"}</dd>
                        </div>
                        <div className="auth-review-list__row">
                          <dt>Address</dt>
                          <dd>{formValues.practiceAddress || "Not added"}</dd>
                        </div>
                        <div className="auth-review-list__row">
                          <dt>Twilio SID</dt>
                          <dd>{formValues.accountSID || "Not provided"}</dd>
                        </div>
                        <div className="auth-review-list__row">
                          <dt>Twilio Token</dt>
                          <dd>{formValues.authToken ? "Provided" : "Not provided"}</dd>
                        </div>
                      </dl>
                    </div>
                  </div>
                </section>
              ) : null}
            </div>

            <div className="login-action-stack auth-register-actions">
              <div className="auth-register-actions__row">
                {currentStep > 1 ? (
                  <button
                    type="button"
                    className="simple-btn register-back-btn auth-register-actions__button auth-register-actions__button--secondary"
                    onClick={previousStep}
                  >
                    Back
                  </button>
                ) : (
                  <button
                    type="button"
                    className="simple-btn register-back-btn auth-register-actions__button auth-register-actions__button--secondary"
                    onClick={loginHandle}
                  >
                    <FontAwesomeIcon className="me-2" icon={faArrowLeftLong} /> Login
                  </button>
                )}

                {currentStep < REGISTER_STEPS.length ? (
                  <button
                    type="button"
                    className="simple-btn login-btn form-hidden login-submit-btn auth-register-actions__button"
                    onClick={nextStep}
                  >
                    Next
                  </button>
                ) : (
                  <button
                    type="button"
                    className="simple-btn login-btn form-hidden login-submit-btn auth-register-actions__button"
                    onClick={handleRegister}
                  >
                    Register
                  </button>
                )}
              </div>
            </div>

          </section>
        </div>
      </div>
    </div>
  );
};
